import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Button } from './Button';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 min-h-[calc(100vh-56px)]">
      {/* Icon container */}
      <div
        className="w-32 h-32 rounded-full flex items-center justify-center mb-6"
        style={{ backgroundColor: 'var(--bg-secondary)' }}
      >
        <Icon size={64} style={{ color: 'var(--text-hint)' }} />
      </div>

      {/* Title */}
      <h2
        className="text-xl font-semibold mb-2 text-center"
        style={{ color: 'var(--text-primary)' }}
      >
        {title}
      </h2>

      {/* Description */}
      <p
        className="text-[15px] text-center mb-8 max-w-sm"
        style={{ color: 'var(--text-hint)' }}
      >
        {description}
      </p>

      {/* Actions */}
      {(primaryAction || secondaryAction) && (
        <div className="w-full max-w-xs space-y-3">
          {primaryAction && (
            <Button
              variant="primary"
              onClick={primaryAction.onClick}
              fullWidth
            >
              {primaryAction.label}
            </Button>
          )}
          {secondaryAction && (
            <Button
              variant="secondary"
              onClick={secondaryAction.onClick}
              fullWidth
            >
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
